import React, { FC, useState } from "react";
import { Badge, Popover } from "antd";
import NotesAction from "./notes";
import AlertsAction from "./alerts";
// import RemindersAction from './reminders';
// import { alerts, allReminders } from "../constants";
// import AddReminders from "@components/addReminder";
// import { notes, notes as notesMockData } from "@components/drawerNotes/mockData";

import "./tableActions.scss";
import { cloneDeep, filter, find, get, noop , set, sortBy} from "lodash";
import moment from "moment";
import {
  MEMBER_LIST_LOCAL,
  CASE_STATUS_REASON_REMINDER,
  CASE_STATUS_REASON_NOTE,
  USER_ACTION_MODULE_MEMBER_LIST,
  USER_ACTION_TAB_DEFAULT,
  USER_ACTION_CARD_MEMBER_LIST_TABLE,
  USER_ACTION_LOCATION_DEFAULT,
  USER_ACTION_DESCRIPTION_REMINDER_SAVE,
  USER_ACTION_DESCRIPTION_REMINDER_DELETE,
  USER_ACTION_DESCRIPTION_REMINDER_UPDATE,
  USER_ACTION_DESCRIPTION_NOTE_UPDATE,
  USER_ACTION_DESCRIPTION_NOTE_DELETE,
  USER_ACTION_DESCRIPTION_NOTE_BOOKMARK,
  USER_ACTION_DESCRIPTION_NOTE_SAVE,
} from "@utils/constants";
import { localToUTCFormatDate } from "@utils/helpers";
import membersService from "@services/members.service";
import NewReminder from "@components/reminder/remindersList/reminder";
import { useMemberListStore } from "@stores/useMemberListStore";
import useSession from "@utils/useSession";
import { CURRENT_ITEM } from "@components/reminder/constants";

type TTableActionsProps = {
  data?: any;
  getMasterData?: any;
};

const TableActions: FC<TTableActionsProps> = ({ data, getMasterData }: TTableActionsProps) => {
  // const [actionType, setActionType] = useState("");
  const [alertData, setAlertData] = useState(data?.alerts || []);
  const [notesData, setNotesData] = useState(data?.notes || []); // Notes data structure should be common for drawer notes and for here (table action)
  // const [remindersData, setReminderData] = useState(data?.reminders || []);
  const [remindersList, setRemindersList] = useState(data?.reminders);
  // const [reminderShow, toggleReminderShow] = useState(false);
  const [isReminderVisible, setIsReminderVisible] = useState(false);
  const [isNoteVisible, setIsNoteVisible] = useState(false);

  const memberListData = useMemberListStore((state) => state.data);
  const setMemberListData = useMemberListStore((state) => state.setMemberListData);
  const session = useSession();

  // useEffect(() => {
  //   setReminderData(data?.reminders);
  // }, [data?.reminders]);

  // const tableAlertHanlder = (data: any) => {
  //   setActionType("alert");

  //   // Row data
  //   console.log("tableAlertHanlder ##", data);
  //   console.log("action type:", actionType);
  //   // based on type (alert, clipboard, calendar) we can get data for action
  //   // getActionData(data.is, type);
  //   setAlertData(alerts);
  // };

  // const tableNotesHanlder = (data: any) => {
  //   setActionType("notes");

  //   console.log("tableNotesHanlder ##", data);
  //   // based on type (alert, clipboard, calendar) we can get data for action
  //   // getActionData(data.is, type);
  //   // setNotesData(notesMockData);
  // };

  // const tableReminderHanlder = (data: any) => {
  //   setActionType("reminder");

  //   console.log("tableReminderHanlder ##", data);
  //   // based on type (alert, clipboard, calendar) we can get data for action
  //   // getActionData(data.is, type);
  //   console.log("remindersData ##", remindersData);
  //   setremindersData(reminders);
  // };

  const noteEditHandler = (updatedNote: any, notesId: any) => {
    let updated = cloneDeep(notesData).map((item: any) => {
      return item.notesId !== notesId ? item : { ...item, notes: updatedNote.description, patientId: updatedNote.patientId, notesCreateDate: moment.utc(), isBookMarked: updatedNote.isBookmarked, recipientType: updatedNote.recipientType};
    });
    updateCaseStatus(USER_ACTION_DESCRIPTION_NOTE_UPDATE, CASE_STATUS_REASON_NOTE, { notes: updated });
    setNotesData(updated);
    data.notes = updated;
  };

  const noteDeleteHandler = (notesId: any) => {
    let updated = cloneDeep(notesData).filter((item: any) => {
      return item.notesId !== notesId;
    });
    updateCaseStatus(USER_ACTION_DESCRIPTION_NOTE_DELETE, CASE_STATUS_REASON_NOTE, { notes: updated });
    setNotesData(updated);
    data.notes = updated;
  };

  const noteBookmarkHandler = (notesId: any) => {
    let updated = cloneDeep(notesData).map((item: any) => {
      if (item.notesId === notesId) {
        item.isBookMarked = !item.isBookMarked;
      }
      return item;
    });
    updateCaseStatus(USER_ACTION_DESCRIPTION_NOTE_BOOKMARK, CASE_STATUS_REASON_NOTE, { notes: updated });
    setNotesData(updated);
    data.notes = updated;
  };

  // const reminderPopOverChange = (popoverState: any) => {
  //   toggleReminderShow(popoverState);
  // };

  const addNoteHandler = (note: any) => {
    let copyData = cloneDeep(notesData);
    let newNote: any = {
      isBookMarked: note.isBookmarked,
      notes: note.data.description,
      notesCreateDate: moment(new Date()),
      notesId: note.data.noteId,
      recipientType: note.data.recipientType,
      careMgrFirstName: session?.user?.firstName,
      careMgrLastName: session?.user?.lastName,
      careMgrId: session?.user?.id
    }
 
    copyData.unshift(newNote);

    setNotesData(copyData);
    setIsNoteVisible(!isNoteVisible);
    updateCaseStatus(USER_ACTION_DESCRIPTION_NOTE_SAVE, CASE_STATUS_REASON_NOTE, { notes: copyData });
    data.notes = copyData;
  };

  const updateAlerts = (alerts: any) => {
    setAlertData(alerts);
  };

  const updateCaseStatus = (userDescription: any, reason: any, payload: any) => {
    const { caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription } = getUserActionParams(userDescription, reason);
    membersService.updateStatus(data?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
      next: (res: any) => {
        if (data?.patient_case_status !== res?.data?.data?.caseStatus) {
          getMasterData();
          const list = cloneDeep(memberListData).map((item: any) => {
            let temp = cloneDeep(item);
            if (data?.patient_id === temp?.patient_id) {
              temp = { ...temp, ...payload };
              temp.patient_case_status = res?.data?.data?.caseStatus;
              temp.case_last_action_date = res?.data?.data?.caseLastActionDate;
            }
            return temp;
          });
          setMemberListData(list);
        }
      },
    });
  };

  const reminderType = {
    reminderType: MEMBER_LIST_LOCAL,
  };

  const handleDeleteAction = ({ toBeDeletedItem , loaderCallback , operationRange = CURRENT_ITEM}: any) => {
    membersService.deleteReminder(toBeDeletedItem.reminderId ,toBeDeletedItem?.parentReminderId , toBeDeletedItem?.reminderStartDate , operationRange).subscribe({
      next: (res) => {

        const deletedReminders = get(res , 'data.data.deletedReminders' , []);

        const _remindersList = filter(remindersList, (reminder) => {
          return !deletedReminders.includes(reminder.reminderId)
        });

        setRemindersList(_remindersList);
        data.reminders = _remindersList;

        updateCaseStatus(USER_ACTION_DESCRIPTION_REMINDER_DELETE, CASE_STATUS_REASON_REMINDER, { reminders: _remindersList });
        loaderCallback();
        // callback();
      },
      error: () => {
        // callback();
        loaderCallback();
      },
    });
  };

  const handleAddAction = ({ toBeAdded }: any, callback = noop) => {
    let reminderCopy = {
      patientId: data.patient_id,
      fromDate: localToUTCFormatDate(toBeAdded?.from),
      toDate: localToUTCFormatDate(toBeAdded?.to),
      description: toBeAdded?.titleVal,
      recurrence: toBeAdded?.recurrence,
      reminderType: reminderType,
      reminderTitle : toBeAdded?.reminderTitle
    };
    membersService.addReminder(reminderCopy.patientId, reminderCopy.fromDate, reminderCopy.toDate, reminderCopy.description, reminderCopy?.recurrence, reminderCopy.reminderType , '' , reminderCopy.reminderTitle).subscribe({
      next: (res) => {
        let response = res.data.data.reminder;

        const newDataForReminders = [
          ...remindersList,
          ...response,
        ];

        setRemindersList(newDataForReminders);

        updateCaseStatus(USER_ACTION_DESCRIPTION_REMINDER_SAVE, CASE_STATUS_REASON_REMINDER, { reminders: newDataForReminders });

        data.reminders = newDataForReminders;

        callback();
      },
      error: () => {
        callback();
      },
    });
  };

  const handleEditAction = ({ reminder }: any, callback = noop) => {
    let reminderCopy = {
      patientId: data.patient_id,
      reminderStartDate: reminder?.reminderStartDate ? localToUTCFormatDate(reminder?.reminderStartDate) : null,
      reminderEndDate: reminder?.reminderEndDate ? localToUTCFormatDate(reminder?.reminderEndDate) : null,
      reminder: reminder?.reminder,
      reminderId: reminder?.reminderId,
      reminderType: reminderType.reminderType,
      recurrence: reminder?.recurrence,
      reminderStatus: reminder?.reminderStatus,
      prevReminderStartDate : reminder?.prevReminderStartDate,
      parentReminderId : reminder.parentReminderId,
      reminderTitle: reminder?.reminderTitle,
      timeZoneOffset: reminder?.timeZoneOffset
    };
    membersService.editReminder(reminderCopy).subscribe({
      next: (res) => {
        const updatedReminderList = res?.data?.data?.reminder?.updatedReminderList;
        const deletedReminderLIst = res?.data?.data?.reminder?.deactivatedReminders;
        const newReminderList = res?.data?.data?.reminder?.newlyCreatedReminders;

        let _remindersList = cloneDeep(remindersList);
        let newDataForReminders : any[] = [];
        
        if(deletedReminderLIst && deletedReminderLIst?.length) {
          _remindersList = _remindersList?.filter((item:any) => !find(deletedReminderLIst, {reminderId : item?.reminderId}))
        }

        if(newReminderList && newReminderList?.length) {
          _remindersList = [..._remindersList, ...newReminderList]
        }

        if(updatedReminderList && updatedReminderList?.length) {
          _remindersList = _remindersList.map((item:any) => {
            let temp = cloneDeep(item);
            const findItem = find(updatedReminderList, {reminderId : item?.reminderId})
            if(findItem) {
              temp = {
                ...temp,
                ...findItem
              }
            }
            return temp
          });
        }

        newDataForReminders = sortBy(_remindersList, "reminderStartDate");

        setRemindersList(newDataForReminders);

        updateCaseStatus(USER_ACTION_DESCRIPTION_REMINDER_UPDATE, CASE_STATUS_REASON_REMINDER, { reminders: newDataForReminders });

        data.reminders = newDataForReminders;

        callback();
      },
      error: () => {
        callback();
      },
    });
  };

  const getUserActionParams = (userActionDescription: any, reason: any) => {
    let props = {
      caseStatusReasonTxt: reason,
      actionModule: USER_ACTION_MODULE_MEMBER_LIST,
      actionTab: USER_ACTION_TAB_DEFAULT,
      actionCard: USER_ACTION_CARD_MEMBER_LIST_TABLE,
      actionLocation: USER_ACTION_LOCATION_DEFAULT,
      actionDescription: userActionDescription,
    };
    return props;
  };

  return (
    <div className="memberlisting-action-wrapper tc">
      {(isNoteVisible || isReminderVisible) && <div className="overlay-modal"></div>}
      <Popover trigger="click" overlayClassName="alertPopoverOverlay" content={<AlertsAction data={alertData} updateMarkStatus={updateAlerts} />} placement="right" destroyTooltipOnHide={true}>
        <Badge dot={alertData.alertsUnReadCount} offset={[-5, 1]} className="alertBadge">
          <span
            className="icon-alert-triangle f20 alertIcon pointer"
            // onClick={() => tableAlertHanlder(data)}
          />
        </Badge>
      </Popover>

      <Popover
        trigger="click"
        overlayClassName="notesPopoverOverlay"
        visible={isNoteVisible}
        content={
          <NotesAction
            patientId={data.patient_id}
            patientStatus={data.patient_case_status}
            data={notesData}
            editHandler={noteEditHandler}
            deleteHandler={noteDeleteHandler}
            bookmarkHandler={noteBookmarkHandler}
            addNoteHanlder={addNoteHandler}
            closePopOver={() => setIsNoteVisible(!isNoteVisible)}
            noteType={MEMBER_LIST_LOCAL}
          />
        }
        placement="right"
        destroyTooltipOnHide={true}
      >
        <Badge offset={[-15, 0]} className="notesBadge">
          <span
            className="icon-clipboard f20 notesIcon pointer"
            // onClick={() => tableNotesHanlder(data)}
            onClick={() => setIsNoteVisible(!isNoteVisible)}
          />
        </Badge>
      </Popover>

      <NewReminder
        listOfReminders={remindersList}
        disabled={false}
        handleDelete={handleDeleteAction}
        handleAdd={handleAddAction}
        handleEdit={handleEditAction}
        closePopOver={() => setIsReminderVisible(!isReminderVisible)}
        member={{
          patientId: data?.patient_id,
          patientName: data?.patient_name,
        }}
        reminderOrigin={MEMBER_LIST_LOCAL}
        isReminderVisible ={isReminderVisible}
        setIsReminderVisible={setIsReminderVisible}
      />
    </div>
  );
};
export default TableActions;
